window.addEventListener('load', function () {
    // obtain cookieconsent plugin
    var cookieconsent = initCookieConsent();

    // run plugin with config object
    cookieconsent.run({
        gui_options: {
            consent_modal: {
                layout: 'box',
                position: 'bottom right',
                transition: 'slide',
            },
            settings_modal: {
                layout: 'box',
                transition: 'slide'
            }
        },
        autorun: true,
        current_lang: 'en',
        autoclear_cookies: true,
        page_scripts: true,

        languages: {
            en: {
                consent_modal: {
                    title: 'Cookie Policy',
                    description: 'We use cookies on this website. You are free to manage these via your browser settings. <a aria-label="Cookie policy" class="cc-link" href="https://myevent.com/cookies">Read more</a>',
                    primary_btn: {
                        text: 'Accept',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Settings',
                        role: 'settings'                // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie preferences',
                    save_settings_btn: 'Save settings',
                    accept_all_btn: 'Accept',
                    blocks: [
                        {
                            title: 'Cookie usage',
                            description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.'
                        }, {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true
                            }
                        }, {
                            title: 'More information',
                            description: 'For any queries in relation to my policy on cookies and your choices, please <a class="cc-link" href="https://myevent.com/contact">contact us</a>.',
                        }
                    ]
                }
            }
        }
    });
});
